import { useAppContext } from '../../../../AppModulesWrapper';
import { useTelemetry } from '../../../../common/hooks';
import * as React from 'react';
import { ReactErrorLog } from './ReactErrorLog';

interface ILogErrorProps {
  children: React.ReactNode;
}

export const LogError = ({ children }: ILogErrorProps) => {
  const { logger } = useAppContext();
  const { increment } = useTelemetry();

  const handleRenderSuccess = React.useCallback(() => {
    increment('success');
  }, [increment]);

  const handleRenderError = React.useCallback(
    (error: Error, errorInfo: React.ErrorInfo) => {
      increment('fail');

      logger.debug('Ошибка рендеринга услуг размещения', {
        name: error.name,
        message: error.message,
        stack: error.stack,
        componentStack: errorInfo.componentStack,
      });
    },
    [increment, logger],
  );

  return (
    <ReactErrorLog onSuccess={handleRenderSuccess} onError={handleRenderError}>
      {children}
    </ReactErrorLog>
  );
};
